export default {
    setToken(state, payload) {
        state.token = payload
        localStorage.setItem("token", payload)
    },
    clearToken(state) {
        state.token = null
        localStorage.removeItem("token")
    },
    changeLayoutMode(state, payload) {
        state.layoutMode = payload;
        localStorage.setItem("layoutMode", payload);
    },
    setGcop(state, value) {
        state.gcop = value;
        if (value) {
            localStorage.setItem("GCOP", 'true');
        } else {
            localStorage.removeItem("GCOP");
        }
    },
    setAdminPermissions(state, permissions) {
        state.adminPermissions = Array.isArray(permissions) ? permissions : [];
        localStorage.setItem('adminPermissions', JSON.stringify(state.adminPermissions));
    },
    clearAdminPermissions(state) {
        state.adminPermissions = [];
        localStorage.removeItem('adminPermissions');
    },
};
